import { render, staticRenderFns } from "./HeroLoading.vue?vue&type=template&id=4a83bc7a&scoped=true&"
var script = {}
import style0 from "./HeroLoading.vue?vue&type=style&index=0&id=4a83bc7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a83bc7a",
  null
  
)

export default component.exports